export enum FactionWorkType {
  Field,
  Hacking,
  None,
  Security,
}
